import styled from "styled-components";

export const Container = styled.div`
  height: 150px;
  text-align: center;
  background: #343a40;
`;

export const Header = styled.h1``;

export const Title = styled.div`
  padding-top: 40px;
  font-size: 40px;
  text-shadow: 2px 2px #8247e5;
  color: #fff;
`;

